import { useRouter } from 'next/navigation';
import Parser from 'html-react-parser';
import { EpIcon } from '../../../EpIcon';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { EpModal, hideModal } from '../../../EpModal';
import {
  useHospitalStore,
  useTranslationStore,
  useUploadStore,
} from '../../../../stores';
import styles from './EpCloseNotificationModal.module.scss';

export const EpCloseNotificationModal = ({
  closeNotificationRoute,
}: {
  closeNotificationRoute: string;
}) => {
  const { translations } = useTranslationStore((state) => state);
  const { hospitalInfo } = useHospitalStore((state) => state);
  const { removeAll } = useUploadStore((state) => state);
  const route = useRouter();
  const buttonLink = hospitalInfo
    ? closeNotificationRoute + '?' + new URLSearchParams({ ...hospitalInfo })
    : closeNotificationRoute;

  return (
    <EpModal
      modalId="close-notification-modal"
      modalTitle={t(translations['global'], 'Exit notification')}
      modalType="danger"
      modalSize="md"
      modalButtonList={[
        {
          buttonId: 'modal__button--close',
          buttonText: t(translations['global'], 'Cancel'),
          buttonType: 'secondary-outline',
          isCloseButton: true,
          buttonSize: 'md',
        },
        {
          buttonId: 'modal__button--save',
          buttonText: t(translations['global'], 'Exit notification'),
          buttonType: 'danger-outline',
          isCloseButton: false,
          buttonLeftIconName: 'SolidSignOutAlt',
          buttonSize: 'md',
          buttonOnClickFunc: () => {
            removeAll();
            route.push(buttonLink);
            hideModal('close-notification-modal');
          },
        },
      ]}
    >
      <div className={styles['content']} style={{ height: 'max-content' }}>
        <div className={styles['content__icon']}>
          <EpIcon
            iconName="SolidSignOutAlt"
            iconSize={48}
            customClasses={styles['content__svg']}
          />
        </div>
        <p className={styles['content__txt']}>
          {Parser(
            t(
              translations['global'],
              'Are you sure you want to exit the notification form ?',
            ),
          )}
        </p>
        <p className={styles['content__label']}>
          {t(
            translations['global'],
            'Upon exiting, you will lose all information entered so far',
          )}
        </p>
      </div>
    </EpModal>
  );
};
